module.exports = {
    sentryEnabled: false,
    coreApi: {
        protocol: 'https',
        host: 'api.ct-development.net'
    },
};
